<div class="table ">
    <table>
        <thead>
            <tr>
                <th>{{'Rating'|translate}}</th>
                <th>{{'Diagnostic Procedure'|translate}}</th>
                <th>{{'State'|translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr mdbTableCol *ngFor="let i of candidateData">
                <th *ngIf="i.rating=='5'">
                    <span *ngFor="let q of [5,5,5,5,5] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='4'">
                    <span *ngFor="let q of [4,4,4,4] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='3'">
                    <span *ngFor="let q of [3,3,3] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='2'">
                    <span *ngFor="let q of [5,5] ">
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <th *ngIf="i.rating=='1'">
                    <span>
                <td>
                    <div class="box"></div>
                </td>
                </span>
                </th>
                <td>{{i.procedure}}</td>
                <td>{{i.state}}</td>
            </tr>
        </tbody>
    </table>
</div>
<div class="box1-left"></div>
<div class="box1"></div>
<div class="box1"></div>
<div class="box1"></div>
<div class="box1"></div>

<div style="padding-top:0%">
    <i style="color:grey; margin-left: 6%;">= {{'Confidence rating'|translate}}</i>
</div>
<div>
    <button class="buttons" (click)="renderOtxCandidate()">{{'RETRY'|translate}}</button>
    <!-- <button class="buttons" routerLink="/info">{{'Diagnostic Candidates'|translate}}</button> -->
    <button class="buttons" *ngIf="btnName == 'Diagnostic Candidates'" routerLink="/info">{{'Diagnostic Candidates'|translate}}</button>
    <button class="buttons" *ngIf="btnName == 'REPAIR CANDIDATES'" routerLink="/repairProcedures">{{'REPAIR CANDIDATES'|translate}}</button>
    <button class="buttons" *ngIf="btnName == 'POST REPAIR CANDIDATES'" routerLink="/postrepairProcedures">{{'POST REPAIR CANDIDATES'|translate}}</button>
</div>
<div *ngIf=showSpinner class="loader2">
    <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
</div>
<div class="contain-popup">
    <ng-template #content let-modal>
        <div class="forborder">
            <div class="modal-header">
                <i class="fa fa-times mng-qualifier-close-btn" style="margin-left: 450px;"
                    (click)="modal.dismiss('Cross click')" title="close">
                </i>
            </div>
            <div class="modal-body">
                <div class="newBorder">
                    {{'pleasecontact'|translate}}: wdmoeuhl@msxi.com
                </div>
            </div>
        </div>
    </ng-template>
</div>
<div id="swUpgrade"></div>
<div class="div-border2" id="LoadingSpinner" *ngIf="showNotification">
    <ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" color="#003478" size="medium"
        type="ball-spin-clockwise" style="margin-top: 0%;">
        <div style="font-size: 12px; color: black; margin-top: 25%; text-align: left !important;">Launching OTX Application. Please wait a moment</div>
    </ngx-spinner>
  </div>
<ng-template #OTXErrorInfo let-c="close" let-d="dismiss">
    <div class="version">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="c('Cross click')"></i></div>
        </div>
        <div>
            <label class='msg-body'>{{'An error occurred when running the application'|translate}}. {{'Cause'|translate}}:{{'technicalproblem'|translate}}.<br>
                {{'Close the message box and try again'|translate}}. {{'Network Test Message1'|translate}}. 
            </label>
        </div>
        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="c('Cross click');navigate()">{{'Continue'|translate | uppercase}}</button>
        </div>
    </div>
</ng-template>
<ng-template #gtacRap let-modal>
    <div class="container NWTContainer">
        <div class="row popup-header1">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('NWTErrorInfo')"></i></div>
        </div>
        <div>
            <label class='msg-body'>
                <p> {{'RAP_Not_Available_Msg'|translate}} </p>
            </label>
        </div>
        <hr class="hr-line1">
        <div class="popup-footer1">
            <button type="button" class="close-btn-popup pull-right" name="GTAC"
                (click)="modal.dismiss('gtacRap');contactSubmit(content)">GTAC</button>
            <!-- <button type="button" class="close-btn-popup pull-right" name="RAP"
                (click)="modal.dismiss('gtacRap');reportAProblemPopup()">RAP</button> -->
        </div>
    </div>
</ng-template>
<ng-template #invalidApp let-c="close" let-d="dismiss">
    <div class="version">
        <div class="row popup-header">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="c('Cross click');navigatePreviousScreen()"></i></div>
        </div>
        <div>
            <label class='msg-body'>{{'InvalidAppMsg'|translate}}.<br> {{'InvalidAppMsg1'|translate}}.  
            </label>
        </div>
        <hr class="hr-line">
        <div class="popup-footer">
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="c('Cross click');raiseGTACForInvalidApp(content)">GTAC</button>
            <button type="button" class="close-btn-popup pull-right" name="cancel"
                (click)="c('Cross click');navigatePreviousScreen()">{{'Continue'|translate | uppercase}}</button>
        </div>
    </div>
</ng-template>
<div class="contain-popup">
    <ng-template #content let-modal>
        <div class="forborder">
            <div class="modal-header">
                <i class="fa fa-times mng-qualifier-close-btn" style="margin-left: 450px;" (click)="modal.dismiss('Cross click')" title="close">
                </i>
            </div>
            <div class="modal-body">
                <div  class="newBorder">
                {{'pleasecontact'|translate}}: wdmoeuhl@msxi.com  
                </div>
            </div>
        </div>
    </ng-template>
</div>
<ng-template #anotherAppActive let-modal>
    <div class="container NWTContainer">
        <div class="row popup-header1">
            <div class="pull-left">{{'Information'|translate}}</div>
            <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                    (click)="modal.dismiss('anotherAppActive')"></i></div>
        </div>
        <div>
            <label class='msg-body'>
                An instance of another application is currently active. Do you wish to abort existing application and automatically retry?
            </label>
        </div>
        <hr class="hr-line1">
        <div class="popup-footer1">
            <button type="button" class="close-btn-popup pull-right" name="GTAC"
                (click)="modal.dismiss('anotherAppActive');abortAnotherAppActive()">Yes</button>
            <button type="button" class="close-btn-popup pull-right" name="RAP"
                (click)="modal.dismiss('anotherAppActive')">No</button>
        </div>
    </div>
    </ng-template>
    
    
